__turbopack_context__.v({
  "square": "styles-module-scss-module__ssLVsa__square",
  "square_image": "styles-module-scss-module__ssLVsa__square_image",
  "squares_container": "styles-module-scss-module__ssLVsa__squares_container",
  "theme_1x4": "styles-module-scss-module__ssLVsa__theme_1x4",
  "theme_2x2": "styles-module-scss-module__ssLVsa__theme_2x2",
});
